(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || drawer.dataset.creditexUpsellReady) return;
  drawer.dataset.creditexUpsellReady = 'true';

  drawer.addEventListener('click', async event => {
    const button = event.target.closest('[data-creditex-upsell-add]');
    if (!button || !drawer.contains(button) || button.disabled) return;
    const variantId = Number(button.dataset.variantId);
    if (!Number.isSafeInteger(variantId)) return;
    const error = drawer.querySelector('.creditex-drawer-suggestions__error');
    if (error) { error.hidden = true; error.textContent = ''; }
    button.disabled = true;
    button.textContent = 'Agregando…';

    try {
      const formData = new FormData();
      formData.append('id', String(variantId));
      formData.append('quantity', '1');
      formData.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
      formData.append('sections_url', window.location.pathname);
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const cart = await response.json();
      if (!response.ok || cart.status || !cart.sections?.['cart-drawer']) {
        throw new Error(cart.description || 'No se pudo agregar este producto.');
      }
      drawer.renderContents(cart);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'creditex-drawer-upsell', cartData: cart, variantId });
      }
    } catch (cause) {
      button.disabled = false;
      button.textContent = 'Agregar';
      if (error) {
        error.textContent = cause.message || 'No se pudo agregar este producto.';
        error.hidden = false;
      }
    }
  });
})();
